// extracted by mini-css-extract-plugin
export default {"ChecklistThemesList__themeListPlaceholder":"ChecklistThemesList-styles__ChecklistThemesList__themeListPlaceholder__hBinN","shimmer":"ChecklistThemesList-styles__shimmer__PL2tv"};